import { Component, Inject } from '@angular/core';
import { AppointmentRequest } from '../../shared/models/appointment-request.model';
import { AppointmentRequestsService } from './appointment-requests.service';
import * as appointmentRequestsActions from './appointment-requests.actions';
import { Group } from '../../shared/models/group.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

@Component({
  selector: 'appointment-requests',
  styles: [require('./appointment-requests.component.scss')],
  template: require('./appointment-requests.component.html'),
})

export class AppointmentRequestsComponent {
  appointmentRequests: AppointmentRequest[];
  group: Group;

  public mobileCharacterLimit = 85;

  constructor(
    @Inject('$ngRedux') public $ngRedux: any,
    @Inject('$state') public $state: any,
    @Inject('$translate') public $translate: any,
    public AppointmentRequestsService: AppointmentRequestsService,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.group = this.$ngRedux.getState().group;
    const patientId = this.$ngRedux.getState().currentPatient.id;
    this.AppointmentRequestsService.get(this.group.id, patientId)
      .subscribe(
        (data) => {
          this.appointmentRequests = data;
          this.store.dispatch(new appointmentRequestsActions.AddAppointmentRequests(this.appointmentRequests));
        },
        err => undefined,
      );
  }

  confirmPage(id) {
    this.$state.go('patients.id.requests.id.cancel', { requestId: id });
  }

  get appointmentRequestsDescription(): string {
    return `
      ${this.$translate.instant('home.appointment_requests.description_line1')}
      ${this.$translate.instant('home.appointment_requests.description_line2')}
      ${this.$translate.instant('home.appointment_requests.description_line3')}
    `;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-requests.component.ts